import { CustomFilters } from './custom-filters';

export class ReportDetailRow extends HTMLElement {
  /**
   * @param {number} user_report_id
   */
  constructor(user_report_id) {
    super();
    this.user_report_id = user_report_id;
  }

  async connectedCallback() {
    let res = await fetch(`/user_report_schedule/${this.user_report_id}`);

    /** @type {import('./custom-filters').ScheduledReportData} */
    let data = await res.json();
    this.data = data;

    this.innerHTML = `
      <div>
        <div class="row">
          <div class="col-xs-12">
            <h3>Report Details</h3>
          </div>
        </div>
        <div class="row custom-filters-container">
        </div>
      </div>
    `;

    this.renderCustomFilters(data.report_type);
  }

  /**
   * @param {string} reportType
   */
  renderCustomFilters(reportType) {
    const customFiltersContainer = /** @type {HTMLDivElement} */ (
      this.querySelector('.custom-filters-container')
    );

    const customFilters = /** @type {import('./custom-filters').CustomFilters} */ (
      document.createElement('custom-filters')
    );
    customFilters.setAttribute('reporttype', reportType);
    if (this.data) {
      customFilters.data = this.data;
    } else {
      throw new Error('Report has no data');
    }

    customFiltersContainer.appendChild(customFilters);
  }
}

customElements.define('report-detail-row', ReportDetailRow);
